import { Box } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const GaragesContainer = styled(Box)`
  padding: 6px 0px 41px 19px;
  width:105%;
  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const HeaderSection = styled(Box)`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 24px;
`;

export const CountDisplay = styled(Box)`
  display: flex;
  width: 118.75px;
  padding: 1.848px;
  flex-direction: row;
  align-items: center;
  gap: 1.848px;
  flex-shrink: 0;
  border-radius: 3.696px;
`;

export const CountDigit = styled(Box)`
  width: 26.884px;
  height: 26.884px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  svg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  
  span {
    position: relative;
    z-index: 1;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 24.195px;
    font-style: normal;
    font-weight: 600;
    line-height: 29.572px;
    letter-spacing: -0.067px;
    background: linear-gradient(180deg, #B595FF -46.59%, #5D4F96 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-edge: cap;
  }
`;

export const CountPlus = styled(Text)`
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.091px;
  background: linear-gradient(180deg, #9399D0 0%, #594A92 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-edge: cap;
  margin-left: 2px;
`;

export const MainHeading = styled(Text)`
  color: var(--Purple-P500, #451999);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const SubHeading = styled(Text)`
  color: var(--text-secondary-n-400, #5B5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
`;

export const WrenchIcon = styled.img`
  width: 108px;
  height: 48px;
  top: -8px;
  right: 0;
  z-index: 1000;
  margin-left: 100px;
  @media (min-width: 768px) {
    width: 64px;
    height: 64px;
  }
`;

export const CardsSection = styled(Box)`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin-bottom: 20px;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const GarageCard = styled(Box)`
  background: white;
  border-radius: 12px;
  padding: 16px;
  min-width: 200px;
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid var(--line-primary-n-200, #E7E7F0);  
  width: 247px;
`;

export const GarageName = styled(Text)`
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  align-self: stretch;
  margin-bottom: 4px;
`;

export const RatingDistance = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  
  span {
    color: var(--text-secondary-n-400, #5B5675);
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
`;

export const StarIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const GarageAddress = styled(Text)`
  color: var(--text-secondary-n-400, #5B5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const CtaSection = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const CtaText = styled(Text)`
  color: #000;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const ArrowIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const ArrowIconWrapper = styled(Box)`
  width: 24px;
  height: 24px;
  margin-top:4px;
`;